import {
  callApiCapNhatThuTu,
  callApiLayDanhSachCapDonVi,
  callApiLayDanhSachCapDonViPaging,
  callApiSuaCapDonVi,
  callApiTaoCapDonVi,
  callApiXoaCapDonVi,
  callApiLayThuTuMacDinh
} from "@/api/cap-don-vi";

import {
  SUA_CAP_DON_VI_THANH_CONG,
  THEM_MOI_CAP_DON_VI_THANH_CONG,
  XOA_CAP_DON_VI_THANH_CONG
} from "@/constants/message";
import { showMsgOk, showMsgError } from "@/utils/commonUtils";

const layDanhSachCapDonVi = async ({ commit }, payload) => {
  const response = await callApiLayDanhSachCapDonVi(payload);
  if (response && response.data.succeeded) {
    commit("LAY_DANH_SACH_CAP_DON_VI_THANH_CONG", response.data.data);
  }
};

const layDanhSachCapDonViPaging = async ({ commit }, payload) => {
  const response = await callApiLayDanhSachCapDonViPaging(payload);
  if (response && response.data.succeeded) {
    commit("LAY_DANH_SACH_CAP_DON_VI_PAGING_THANH_CONG", response.data.data);
  }
};

const themCapDonVi = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    callApiTaoCapDonVi(payload.data)
      .then(res => {
        resolve(res);
        showMsgOk(THEM_MOI_CAP_DON_VI_THANH_CONG);
        commit("THEM_MOI_CAP_DON_VI_THANH_CONG", response.data.data);
        payload.onSuccess();
      })
      .catch(err => {
        reject(err.response);
      });
  });
};

const suaCapDonVi = async ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    callApiSuaCapDonVi(payload.data)
      .then(res => {
        resolve(res);
        showMsgOk(SUA_CAP_DON_VI_THANH_CONG);
        commit("SUA_CAP_DON_VI_THANH_CONG", response.data.data);
        payload.onSuccess();
      })
      .catch(err => {
        reject(err.response);
      });
  });
};

// eslint-disable-next-line no-empty-pattern
const xoaCapDonVi = async (context, payload) => {
  return new Promise(resolve => {
    callApiXoaCapDonVi(payload.data)
      .then(res => {
        showMsgOk(XOA_CAP_DON_VI_THANH_CONG);
        payload.onSuccess();
      })
      .catch(err => {
        showMsgError(err.response.data.message);
      });
  });
};
// eslint-disable-next-line no-empty-pattern
const capNhatThuTu = async (context, payload) => {
  const response = await callApiCapNhatThuTu(payload.data);
  if (response && response.data.succeeded) {
    // payload.onSuccess();
  }
};

const layThuTuMacDinh = async (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayThuTuMacDinh(payload)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err.response);
      });
  });
};

export default {
  layDanhSachCapDonVi,
  layDanhSachCapDonViPaging,
  themCapDonVi,
  suaCapDonVi,
  xoaCapDonVi,
  capNhatThuTu,
  layThuTuMacDinh
};
